import React from 'react';
import { Redirect } from 'react-router-dom';
import { BASE_URL } from '../../config/constant';
import { MAIN_URL } from '../../config/constant';
import useAuth from '../../hooks/useAuth';
import { useCommonContext } from 'src/contexts/CommonContext';
import { useRedirectJourney } from 'src/hooks/useRedirectJourney';

const GuestGuard = ({ children }) => {
  const ParseData = JSON.parse(localStorage.getItem('User'));
  const journeyDetails = ParseData?.journeyDetails || {};
  const { isLoggedIn } = useAuth();
  const { commonState } = useCommonContext()
  const queryParams = new URLSearchParams(window.location.search);
  const referal = queryParams.get('referal');
  const selectedProfileId = JSON.parse(sessionStorage.getItem('selectedProfileId'));

  if (isLoggedIn) {
    if (ParseData?.planDetails?.only_mcp === true) return <Redirect to="/profile" />;
    const redirect = useRedirectJourney(journeyDetails);
    if(redirect) return redirect;
    if (referal == 'sp') {
      return <Redirect to='/addaccount' />
    } 
    
    // else if (selectedProfileId?.permissions?.length > 0 && ParseData?.profileStatus == true) {
    //   const customOrder = ["Sponsored Ads", "DSP", "AMC"];
    //   const sortedPermissions = [...selectedProfileId?.permissions].sort(
    //     (a, b) => customOrder.indexOf(a) - customOrder.indexOf(b)
    //   );
    //   const firstPermission = sortedPermissions[0];
    //   switch (firstPermission) {
    //     case "Sponsored Ads":
    //       return <Redirect to="/amazon-snapshot/welcome" />
    //     case "DSP":
    //       return <Redirect to="/amazon-dsp/campaign" />
    //     case "AMC":
    //       return <Redirect to="/amazon-audience-instance" />
    //     default:
    //       return <Redirect to="/amazon-snapshot/welcome" />
    //   }
    // } 
    
    else {
      // Fixed: Proper priority chain for platform redirects
      if (ParseData?.profileStatus == true) {
        const mainUrl = ParseData?.isAgency ? '/amazon-dsp/campaign' : '/amazon/targeting';
        return <Redirect to={mainUrl} />;
      } else if (ParseData?.DSPProfileStatus == true) {
        return <Redirect to='/amazon-dsp/campaign' />;
      } else if (ParseData?.flipkartProfileStatus == true) {
        return <Redirect to='/summary/flipkart' />;
      } else if (ParseData?.instamartProfileStatus == true) {
        return <Redirect to='/summary/instamart' />;
      } else if (ParseData?.myntraProfileStatus == true) {
        return <Redirect to='/summary/myntra' />;
      } else if (ParseData?.zeptoProfileStatus == true) {
        return <Redirect to='/summary/zepto' />;
      } else if (ParseData?.bigbasketProfileStatus == true) {
        return <Redirect to='/summary/bigbasket' />;
      } else if (ParseData?.DSPPendingStatus === true) {
        return <Redirect to='/amazon-dsp-request' />;
      } else if (ParseData?.isSubscribed === true) {
        return <Redirect to='/addaccount' />;
      } else {
        return <Redirect to='/getting-started' />;
      }
    }
  }

  return <React.Fragment>{children}</React.Fragment>;
};

export default GuestGuard;
